import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'

import { BenefitsList } from '../../benefits-list'
import { Pipedrive4BizButton } from '../../pipedrive-4-biz-button'
import { LinkedAccountLockAiContent_OfferLockDataFragment } from './__generated__/ai-content.graphql'
import styles from './ai-content.module.scss'
import { JusAILogo } from './jus-ai-logo'

interface AIContentProps {
  offerLockData: LinkedAccountLockAiContent_OfferLockDataFragment
}

export function AiContent({ offerLockData }: AIContentProps) {
  if (!offerLockData.body.cards.length) {
    return null
  }
  const { body, header } = offerLockData
  const [card] = body.cards
  const { title, subtitle } = header

  return (
    <>
      <div className={styles.header}>
        <JusAILogo width={80} height={22} />
        <Heading size="lg" className={styles.title}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
        <BodyText size="md" className={styles.subtitle}>
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
      </div>

      <BenefitsList offerLockCard={card} benefitsListClassName={styles.benefits} />

      <div className={styles.actionBtn}>
        <Pipedrive4BizButton offerLockCard={card} />
      </div>
    </>
  )
}

AiContent.fragments = {
  offerLockData: gql`
    fragment LinkedAccountLockAiContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          buttons {
            label
            url
          }
          ...BenefitsList_offerLockCard
          ...Pipedrive4BizButton_offerLockCard
        }
      }
    }
    ${BenefitsList.fragments.offerLockCard}
    ${Pipedrive4BizButton.fragments.offerLockCard}
  `,
}
